import React from 'react';
import {connect} from 'react-redux';
import {BaseUsedTeams} from 'components/organisms/used-teams/components/sports/mlb';
import {calcPercentage} from 'helpers/common-helper';
import {TeamExposureInput} from 'components/organisms/used-teams/components/team-exposure-input';

class UsedTeamsComponent extends BaseUsedTeams {
    render() {
        const {lineups, rawLineups} = this.props;

        if (isEmpty(lineups.all())) {
            return null;
        }

        const lineupsList = lineups.all();
        const teamList = this.prepareTeams(this.groupTeamUsage(lineupsList));
        const countLineups = Object.keys(lineupsList).length;
        const usedTeams = [];

        if (countLineups > 0) {
            Object.values(teamList).map((team, index) => {
                const percentage = calcPercentage(countLineups, team.usedLineupsCount);

                usedTeams.push(
                    <tbody key={index} className={this.getRowClassName(team, index)}>
                        <tr>
                            <td>
                                <strong>{team.name}</strong>
                            </td>
                            <td className="text-blue">
                                <span className="percent-in inline-text">{percentage}%</span>({team.usedLineupsCount})
                            </td>
                            <td>
                                <div className="percent-in">
                                    <TeamExposureInput team={team.name} className="form-control small-table-input" />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>,
                );
            });
        } else {
            usedTeams.push(this.getNotFoundView());
        }

        return (
            <div className="players-used-table table-holder">
                <div className="sticky-table">
                    <table className="players-table">
                        <tbody>
                            <tr>
                                <th>Team</th>
                                <th>Exp%</th>
                                <th>Exp.max</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table className="players-table">{usedTeams}</table>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups, rawLineups},
        usedTeams,
    } = state;
    return {
        lineups,
        rawLineups,
        usedTeams,
    };
}

let UsedTeams = connect(mapStatesToProps)(UsedTeamsComponent);

export {UsedTeams};
